import {
    userCancelModelUpdate,
    userApplyModelUpdate
} from "../../../../actions/user-actions"

import buildEditFormActionButtonsWidgetContainer from "../../../common/build-edit-form-action-buttons-widget-container"

export default buildEditFormActionButtonsWidgetContainer(
    userApplyModelUpdate,
    userCancelModelUpdate,
    "users"
)
